import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function ExternalLinkIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Icons">
        <path
          id="Vector"
          d="M10 5.5H5C4.55798 5.5 4.13405 5.6756 3.82149 5.98816C3.50893 6.30072 3.33334 6.72464 3.33334 7.16667V15.5C3.33334 15.942 3.50893 16.366 3.82149 16.6785C4.13405 16.9911 4.55798 17.1667 5 17.1667H13.3333C13.7754 17.1667 14.1993 16.9911 14.5118 16.6785C14.8244 16.366 15 15.942 15 15.5V10.5M9.16667 11.3333L16.6667 3.83334M16.6667 3.83334H12.5M16.6667 3.83334V8"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  )
}
